import React from 'react'
import PropTypes from 'prop-types'
import { Link } from 'react-router-dom/cjs/react-router-dom.min'
export default function Navbar(props) {
            
  return (
    <nav className={`navbar navbar-expand-lg navbar-${props.mode} bg-${props.mode}`} >
        <div className="container-fluid">
            <Link className="navbar-brand" to="/">{props.title}</Link>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span className="navbar-toggler-icon"></span>
            </button>
                <div className="collapse navbar-collapse" id="navbarSupportedContent">
                    <ul className="navbar-nav me-auto mb-2 mb-lg-0">
                        <li className="nav-item">
                        <Link className="nav-link active" aria-current="page" to="/">Home</Link>
                        </li>
                        <li>
                        <Link className="nav-link active" to="/about">About Us</Link>
                        </li>
                       
                    </ul>
                    <form className="d-flex" role="search">
                        {/* <input className="form-control me-2" type="search" placeholder="Search" aria-label="Search"/> */}
                        {/* <button className="btn btn-primary" type="submit">Search</button> */}
                    </form>
                    <div className={`form-check form-switch text-${props.mode==='light'?'dark':'light'}`}>
                    <input className="form-check-input mx-1" onClick={props.toggleMode} type="checkbox" role="switch" id="switchCheckDefault"/>
                    <label className="form-check-label" htmlFor="switchCheckDefault">Enable Dark Mode</label>
                    </div>
                </div>
        </div>
    </nav>

    )
}

Navbar.propTypes = {
     title: PropTypes.string,
     aboutText: PropTypes.string
    }

Navbar.defaultProps = {
     title: 'Text Tools',
     aboutText: 'About Us' 
    }